export enum SymbolLayerType {
    STANDARD_SYMBOLS = 0,
    SPECIAL_SYMBOLS = 1,
    SPECIAL_SCATTER_SYMBOLS = 2,

    UNMASKED_STANDARD_SYMBOLS = 3,
    UNMASKED_SPECIAL_WILD_SYMBOLS = 4,
    UNMASKED_SPECIAL_SYMBOLS = 5,
    UNMASKED_SPECIAL_SCATTER_SYMBOLS = 6,

    WINNING_SYMBOLS = 7,

    COUNT = 8,
}
